const ConditionFieldMixins = {
  props: {
    field: {
      type: Skylark.App.Model.Field.Base,
      required: true
    },
    judgements: Object
  }
};

export default ConditionFieldMixins;
